// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Form,
//   Button,
//   Row,
//   Col,
//   CloseButton,
//   InputGroup,
// } from "react-bootstrap";
// import { format, addDays, differenceInCalendarDays, parseISO } from "date-fns";
// import api from "../../../../api/axios";

// const BookingSidebar = ({
//   isOpen,
//   onClose,
//   mode = "add",
//   data = null,
//   onAddReservation,
//   rooms = [],
//   roomTypes = [],
//   rateTypes = [],
// }) => {
//   const availableRateTypesForRoomType = (roomTypeId) => {
//     if (!roomTypeId) return [];
//     return rateTypes.filter(
//       (rt) => Number(rt.room_type_id) === Number(roomTypeId)
//     );
//   };

//   const findRooms = (roomTypeId) => {
//     if (!roomTypeId) return [];
//     return rooms.filter((r) => Number(r.room_type?.id) === Number(roomTypeId));
//   };

//   const emptyRoomRow = (uid = "r-" + Date.now()) => ({
//     uid,
//     room_type_id: null,
//     rate_type_id: null,
//     room_id: null,
//     adults: 1,
//     children: 0,
//     rate: 0,
//   });

//   const [guestTitle, setGuestTitle] = useState("Mr");
//   const [guestName, setGuestName] = useState("");
//   const [guestMobile, setGuestMobile] = useState("");
//   const [guestEmail, setGuestEmail] = useState("");
//   const [override, setOverride] = useState(false);
//   const [price, setPrice] = useState(0);

//   const [guestSuggestions, setGuestSuggestions] = useState([]);
//   const [showGuestDropdown, setShowGuestDropdown] = useState(false);

//   const [checkIn, setCheckIn] = useState(format(new Date(), "yyyy-MM-dd"));
//   const [checkOut, setCheckOut] = useState(
//     format(addDays(new Date(), 1), "yyyy-MM-dd")
//   );

//   const [roomRows, setRoomRows] = useState([emptyRoomRow()]);
//   const [remarks, setRemarks] = useState("");

//   const fetchGuestSuggestions = async (text) => {
//     if (text.length < 3) {
//       setShowGuestDropdown(false);
//       return;
//     }

//     try {
//       const res = await api.get(`/pms/guests?search=${text}`);
//       const data = await res.data;
//       setGuestSuggestions(data);
//       setShowGuestDropdown(true);
//     } catch (err) {
//       console.error("Guest search failed", err);
//     }
//   };

//   const handleSelectGuest = (g) => {
//     setGuestName(g.name);
//     setGuestMobile(g.mobile_no);
//     setGuestEmail(g.email);
//     setGuestTitle(g.title || "Mr");

//     setShowGuestDropdown(false);
//   };

//   // -------------------------
//   // CALCULATED FIELDS
//   // -------------------------

//   const nights = useMemo(() => {
//     try {
//       const d1 = parseISO(checkIn);
//       const d2 = parseISO(checkOut);
//       const diff = differenceInCalendarDays(d2, d1);
//       return diff > 0 ? diff : 0;
//     } catch {
//       return 0;
//     }
//   }, [checkIn, checkOut]);

//   const subtotal = useMemo(() => {
//     return roomRows.reduce((sum, r) => sum + (Number(r.rate) || 0) * nights, 0);
//   }, [roomRows, nights]);

//   const total = subtotal;

//   // -------------------------
//   // INITIALIZE WHEN OPEN
//   // -------------------------

//   useEffect(() => {
//     if (!isOpen) return;

//     if (mode === "add") {
//       setGuestTitle("Mr");
//       setGuestName("");
//       setGuestMobile("");
//       setGuestEmail("");
//       setCheckIn(format(new Date(), "yyyy-MM-dd"));
//       setCheckOut(format(addDays(new Date(), 1), "yyyy-MM-dd"));
//       setRoomRows([emptyRoomRow("initial")]);
//       setRemarks("");
//       return;
//     }

//     if (mode !== "add" && data) {
//       setGuestTitle(data.guest?.title || "Mr");
//       setGuestName(data.guest?.name || "");
//       setGuestMobile(data.guest?.mobile_no || "");
//       setGuestEmail(data.guest?.email || "");
//       setCheckIn(
//         data.check_in
//           ? format(new Date(data.check_in), "yyyy-MM-dd")
//           : format(new Date(), "yyyy-MM-dd")
//       );
//       setCheckOut(
//         data.check_out
//           ? format(new Date(data.check_out), "yyyy-MM-dd")
//           : format(addDays(new Date(), 1), "yyyy-MM-dd")
//       );
//     }
//   }, [isOpen]);

//   const updateRow = (uid, key, value) => {
//     setRoomRows((prev) =>
//       prev.map((row) => {
//         if (row.uid !== uid) return row;
//         const updated = { ...row, [key]: value };
//         if (key === "room_type_id") {
//           updated.rate_type_id = null;
//           updated.room_id = null;
//           updated.rate = 0;
//         }
//         if (key === "rate_type_id") {
//           const rt = rateTypes.find((r) => r.id === value);
//           updated.rate = rt ? Number(rt.base_price) : 0;
//           updated.room_id = null;
//         }
//         return updated;
//       })
//     );
//   };

//   const addRoomRow = () => setRoomRows((prev) => [...prev, emptyRoomRow()]);
//   const removeRoomRow = (uid) =>
//     roomRows.length > 1 &&
//     setRoomRows((prev) => prev.filter((r) => r.uid !== uid));

//   const handleSubmit = () => {
//     const payload = {
//       title: guestTitle,
//       name: guestName,
//       mobile_no: guestMobile,
//       email: guestEmail,
//       company_id: null,
//       city_ledger: false,
//       check_in: checkIn + "T14:00:00Z",
//       check_out: checkOut + "T11:00:00Z",
//       source_of_booking: "",
//       arrival_from: "",
//       booking_type: "",
//       booking_reference_no: "",
//       remarks: remarks,
//       rooms: roomRows.map((r) => ({
//         room_id: r.room_id,
//         rate_type_id: r.rate_type_id,
//         override_price: override ? Number(price) : null,
//         adults: r.adults,
//         children: r.children,
//       })),
//     };
//     console.log(payload);
//     // const reservation = {
//     //   id: Math.floor(Math.random() * 9999999),
//     //   check_in: checkIn + "T14:00:00Z",
//     //   check_out: checkOut + "T11:00:00Z",
//     //   nights,
//     //   total,
//     //   remarks,

//     //   rooms: roomRows.map((r) => ({
//     //     room_type_id: r.room_type_id,
//     //     rate_type_id: r.rate_type_id,
//     //     room_id: r.room_id,
//     //     adults: r.adults,
//     //     children: r.children,
//     //     rate: r.rate,
//     //     line_total: r.rate * nights,
//     //   })),

//     //   guest: {
//     //     title: guestTitle,
//     //     name: guestName,
//     //     mobile_no: guestMobile,
//     //     email: guestEmail,
//     //   },
//     // };
//     // onAddReservation(reservation);
//     onClose();
//   };

//   if (!isOpen) return null;

//   return (
//     <>
//       <div className="right-sidebar-overlay open" onClick={onClose}></div>
//       <div
//         className="right-sidebar open bg-white shadow-lg"
//         style={{
//           width: "700px",
//           right: 0,
//           top: 0,
//           bottom: 0,
//           position: "fixed",
//           zIndex: 2000,
//           overflowY: "auto",
//         }}
//       >
//         <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
//           <h5 className="mb-0">Add New Booking</h5>
//           <CloseButton onClick={onClose} />
//         </div>
//         <div className="p-3">
//           <Row className="g-2 mb-3">
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Check-in</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={checkIn}
//                   onChange={(e) => {
//                     const v = e.target.value;
//                     setCheckIn(v);
//                     const minOut = format(
//                       addDays(parseISO(v), 1),
//                       "yyyy-MM-dd"
//                     );
//                     if (parseISO(checkOut) <= parseISO(v)) setCheckOut(minOut);
//                   }}
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Check-out</Form.Label>
//                 <Form.Control
//                   type="date"
//                   min={format(addDays(parseISO(checkIn), 1), "yyyy-MM-dd")}
//                   value={checkOut}
//                   onChange={(e) => setCheckOut(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Nights</Form.Label>
//                 <Form.Control value={nights} readOnly />
//               </Form.Group>
//             </Col>

//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Rooms</Form.Label>
//                 <Form.Control value={roomRows.length} readOnly />
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="mb-2 d-flex justify-content-between">
//             <h6 className="text-muted text-uppercase small">Rooms</h6>
//             <Button size="sm" onClick={addRoomRow} variant="outline-primary">
//               + Add Room
//             </Button>
//           </div>
//           {roomRows.map((row) => (
//             <div key={row.uid} className="border rounded p-2 mb-3 bg-light">
//               <Row className="g-2 align-items-center">
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small text-muted fw-semibold">
//                       Room Type
//                     </Form.Label>
//                     <Form.Select
//                       value={row.room_type_id || ""}
//                       onChange={(e) =>
//                         updateRow(
//                           row.uid,
//                           "room_type_id",
//                           Number(e.target.value)
//                         )
//                       }
//                     >
//                       <option value="">Select Type</option>
//                       {roomTypes.map((t) => (
//                         <option key={t.id} value={t.id}>
//                           {t.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small text-muted fw-semibold">
//                       Rate Type
//                     </Form.Label>
//                     <Form.Select
//                       value={row.rate_type_id || ""}
//                       disabled={!row.room_type_id}
//                       onChange={(e) =>
//                         updateRow(
//                           row.uid,
//                           "rate_type_id",
//                           Number(e.target.value)
//                         )
//                       }
//                     >
//                       <option value="">Select Rate</option>
//                       {availableRateTypesForRoomType(row.room_type_id).map(
//                         (rt) => (
//                           <option key={rt.id} value={rt.id}>
//                             {rt.name}
//                           </option>
//                         )
//                       )}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small text-muted fw-semibold">
//                       Room
//                     </Form.Label>
//                     <Form.Select
//                       value={row.room_id || ""}
//                       disabled={!row.room_type_id}
//                       onChange={(e) =>
//                         updateRow(row.uid, "room_id", Number(e.target.value))
//                       }
//                     >
//                       <option value="">Select Room</option>
//                       {findRooms(row.room_type_id).map((room) => (
//                         <option key={room.id} value={room.id}>
//                           {room.room_number} — {room.status}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small text-muted fw-semibold">
//                       Rate
//                     </Form.Label>
//                     <InputGroup className="mt-2" style={{ width: "150px" }}>
//                       <InputGroup.Text>
//                         <Form.Check
//                           type="switch"
//                           id="override-switch"
//                           checked={override}
//                           onChange={(e) => setOverride(e.target.checked)}
//                         />
//                       </InputGroup.Text>
//                       <Form.Control
//                         type="number"
//                         value={row.rate || 0}
//                         onChange={(e) => setPrice(e.target.value)}
//                         disabled={!override}
//                         style={{
//                           backgroundColor: override ? "white" : "#f1f3f4",
//                           cursor: override ? "text" : "not-allowed",
//                         }}
//                       />
//                     </InputGroup>
//                     {/* <InputGroup>
//                       <Form.Control
//                         type="number"
//                         disabled={!row.rate_type_id}
//                         value={row.rate || 0}
//                         onChange={(e) =>
//                           updateRow(row.uid, "rate", Number(e.target.value))
//                         }
//                       />
//                     </InputGroup> */}
//                   </Form.Group>
//                 </Col>
//                 <Col md={1} className="text-end">
//                   <Button
//                     variant="outline-danger"
//                     size="sm"
//                     className="mt-4"
//                     onClick={() => removeRoomRow(row.uid)}
//                   >
//                     ✕
//                   </Button>
//                 </Col>
//               </Row>
//               <Row className="g-2 mt-2">
//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small text-muted fw-semibold">
//                       Adults
//                     </Form.Label>
//                     <Form.Select
//                       value={row.adults}
//                       disabled={!row.room_type_id}
//                       onChange={(e) =>
//                         updateRow(row.uid, "adults", Number(e.target.value))
//                       }
//                     >
//                       {[1, 2, 3, 4].map((n) => (
//                         <option key={n} value={n}>
//                           {n}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small text-muted fw-semibold">
//                       Children
//                     </Form.Label>
//                     <Form.Select
//                       value={row.children}
//                       disabled={!row.room_type_id}
//                       onChange={(e) =>
//                         updateRow(row.uid, "children", Number(e.target.value))
//                       }
//                     >
//                       {[0, 1, 2, 3].map((n) => (
//                         <option key={n} value={n}>
//                           {n}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3} className="d-flex flex-column justify-content-end">
//                   <div className="small text-muted">Line Total</div>
//                   <div className="fw-bold fs-6">
//                     {(row.rate * nights).toLocaleString()}
//                   </div>
//                 </Col>
//               </Row>
//             </div>
//           ))}
//           <h6 className="text-muted text-uppercase small mt-4">
//             Guest Information
//           </h6>
//           <Row className="g-2 mb-3">
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Title</Form.Label>
//                 <Form.Select
//                   value={guestTitle}
//                   onChange={(e) => setGuestTitle(e.target.value)}
//                 >
//                   <option>Mr</option>
//                   <option>Ms</option>
//                   <option>Mrs</option>
//                   <option>Dr</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Full Name</Form.Label>
//                 <div style={{ position: "relative" }}>
//                   <Form.Control
//                     value={guestName}
//                     onChange={(e) => {
//                       setGuestName(e.target.value);
//                       fetchGuestSuggestions(e.target.value);
//                     }}
//                   />
//                   {showGuestDropdown && guestSuggestions.length > 0 && (
//                     <div
//                       style={{
//                         position: "absolute",
//                         top: "100%",
//                         left: 0,
//                         right: 0,
//                         background: "white",
//                         border: "1px solid #ddd",
//                         zIndex: 9999,
//                         maxHeight: "200px",
//                         overflowY: "auto",
//                         borderRadius: "4px",
//                       }}
//                     >
//                       {guestSuggestions.map((g) => (
//                         <div
//                           key={g.id}
//                           onClick={() => handleSelectGuest(g)}
//                           style={{
//                             padding: "8px",
//                             cursor: "pointer",
//                             borderBottom: "1px solid #eee",
//                           }}
//                         >
//                           <strong>{g.name}</strong>
//                           <div className="text-muted small">{g.mobile_no}</div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Mobile</Form.Label>
//                 <Form.Control
//                   value={guestMobile}
//                   onChange={(e) => setGuestMobile(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row className="g-2 mb-3">
//             <Col md={8}>
//               <Form.Group>
//                 <Form.Label>Email</Form.Label>
//                 <Form.Control
//                   value={guestEmail}
//                   onChange={(e) => setGuestEmail(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>
//           <Form.Group className="mb-3">
//             <Form.Label>Remarks</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={2}
//               value={remarks}
//               onChange={(e) => setRemarks(e.target.value)}
//             />
//           </Form.Group>
//           <Row className="mb-3">
//             <Col md={6}>
//               <div className="small text-muted">Subtotal</div>
//               <div className="fw-bold">₹{subtotal.toLocaleString()}</div>
//             </Col>
//             <Col md={6} className="text-end">
//               <div className="small text-muted">Total</div>
//               <div className="fw-bold fs-4">₹{total.toLocaleString()}</div>
//             </Col>
//           </Row>
//           <div className="d-grid gap-2">
//             <Button onClick={handleSubmit} variant="primary">
//               Save Booking
//             </Button>
//             <Button variant="secondary" onClick={onClose}>
//               Cancel
//             </Button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BookingSidebar;

import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  CloseButton,
  InputGroup,
} from "react-bootstrap";
import { format, addDays, differenceInCalendarDays, parseISO } from "date-fns";
import api from "../../../../api/axios";
import Swal from "sweetalert2";

const BookingSidebar = ({
  isOpen,
  onClose,
  mode = "add",
  data,
  onAddReservation,
  rooms = [],
  roomTypes = [],
  rateTypes = [],
}) => {
  const availableRateTypesForRoomType = (roomTypeId) => {
    if (!roomTypeId) return [];
    return rateTypes.filter(
      (rt) => Number(rt.room_type_id) === Number(roomTypeId)
    );
  };

  const findRooms = (roomTypeId) => {
    if (!roomTypeId) return [];
    return rooms.filter((r) => Number(r.room_type?.id) === Number(roomTypeId));
  };

  const emptyRoomRow = (uid = "r-" + Date.now()) => ({
    uid,
    room_type_id: null,
    rate_type_id: null,
    room_id: null,
    adults: 1,
    children: 0,
    rate: 0,
    override: false, // ✔ NEW per-room override
  });

  // -------------------------
  // STATES
  // -------------------------

  const [guestTitle, setGuestTitle] = useState("Mr");
  const [guestName, setGuestName] = useState("");
  const [guestMobile, setGuestMobile] = useState("");
  const [guestEmail, setGuestEmail] = useState("");

  const [guestSuggestions, setGuestSuggestions] = useState([]);
  const [showGuestDropdown, setShowGuestDropdown] = useState(false);

  const [checkIn, setCheckIn] = useState(format(new Date(), "yyyy-MM-dd"));
  const [checkOut, setCheckOut] = useState(
    format(addDays(new Date(), 1), "yyyy-MM-dd")
  );

  const [roomRows, setRoomRows] = useState([emptyRoomRow()]);
  const [remarks, setRemarks] = useState("");

  const validateBooking = () => {
    if (!guestName.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Guest Name",
        text: "Please enter the guest's full name.",
      });
      return false;
    }

    if (!guestMobile.trim() && !guestEmail.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Contact Required",
        text: "Please enter either mobile number or email.",
      });
      return false;
    }

    if (!checkIn || !checkOut) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Dates",
        text: "Please select both check-in and check-out dates.",
      });
      return false;
    }

    if (parseISO(checkOut) <= parseISO(checkIn)) {
      Swal.fire({
        icon: "warning",
        title: "Date Error",
        text: "Check-out must be after check-in.",
      });
      return false;
    }

    for (let r of roomRows) {
      if (!r.room_type_id) {
        Swal.fire({
          icon: "warning",
          title: "Room Type Required",
          text: "Please select a room type.",
        });
        return false;
      }

      if (!r.rate_type_id) {
        Swal.fire({
          icon: "warning",
          title: "Rate Type Required",
          text: "Please select a rate type.",
        });
        return false;
      }

      if (!r.room_id) {
        Swal.fire({
          icon: "warning",
          title: "Room Required",
          text: "Please select a room number.",
        });
        return false;
      }
    }

    return true;
  };

  // -------------------------
  // GUEST SEARCH
  // -------------------------
  console.log(data);
  const fetchGuestSuggestions = async (text) => {
    if (text.length < 3) {
      setShowGuestDropdown(false);
      return;
    }

    try {
      const res = await api.get(`/pms/guests?search=${text}`);
      const data = res.data;
      setGuestSuggestions(data);
      setShowGuestDropdown(true);
    } catch (err) {
      console.error("Guest search failed", err);
    }
  };

  const handleSelectGuest = (g) => {
    setGuestName(g.name);
    setGuestMobile(g.mobile_no);
    setGuestEmail(g.email);
    setGuestTitle(g.title || "Mr");
    setShowGuestDropdown(false);
  };

  // -------------------------
  // CALCULATED FIELDS
  // -------------------------

  const nights = useMemo(() => {
    try {
      const d1 = parseISO(checkIn);
      const d2 = parseISO(checkOut);
      const diff = differenceInCalendarDays(d2, d1);
      return diff > 0 ? diff : 0;
    } catch {
      return 0;
    }
  }, [checkIn, checkOut]);

  const subtotal = useMemo(() => {
    return roomRows.reduce((sum, r) => sum + Number(r.rate) * nights, 0);
  }, [roomRows, nights]);

  const total = subtotal;

  // -------------------------
  // INITIALIZE WHEN OPEN
  // -------------------------

  useEffect(() => {
    if (!isOpen) return;

    if (mode === "add") {
      setGuestTitle("Mr");
      setGuestName("");
      setGuestMobile("");
      setGuestEmail("");
      if (data?.check_in) {
        setCheckIn(data.check_in);
        setCheckOut(data.check_out);
      } else {
        setCheckIn(format(new Date(), "yyyy-MM-dd"));
        setCheckOut(format(addDays(new Date(), 1), "yyyy-MM-dd"));
      }

      // Auto-fill room type + room
      if (data?.room_type_id) {
        setRoomRows([
          {
            uid: "initial",
            room_type_id: data.room_type_id,
            rate_type_id: null,
            room_id: null,
            adults: 1,
            children: 0,
            rate: 0,
            override: false,
          },
        ]);
      } else {
        setRoomRows([emptyRoomRow("initial")]);
      }

      setRemarks("");
      return;
    }
    // setCheckIn(format(new Date(), "yyyy-MM-dd"));
    // setCheckOut(format(addDays(new Date(), 1), "yyyy-MM-dd"));
    // setRoomRows([emptyRoomRow("initial")]);
    // setRemarks("");
    // return;
    // }

    if (mode !== "add" && data) {
      setGuestTitle(data.guest?.title || "Mr");
      setGuestName(data.guest?.name || "");
      setGuestMobile(data.guest?.mobile_no || "");
      setGuestEmail(data.guest?.email || "");

      setCheckIn(
        data.check_in
          ? format(new Date(data.check_in), "yyyy-MM-dd")
          : format(new Date(), "yyyy-MM-dd")
      );

      setCheckOut(
        data.check_out
          ? format(new Date(data.check_out), "yyyy-MM-dd")
          : format(addDays(new Date(), 1), "yyyy-MM-dd")
      );
    }
  }, [isOpen]);

  // -------------------------
  // ROOM ROW LOGIC
  // -------------------------

  const updateRow = (uid, key, value) => {
    setRoomRows((prev) =>
      prev.map((row) => {
        if (row.uid !== uid) return row;
        const updated = { ...row, [key]: value };

        if (key === "room_type_id") {
          updated.rate_type_id = null;
          updated.room_id = null;
          updated.rate = 0;
          updated.override = false;
        }

        if (key === "rate_type_id") {
          const rt = rateTypes.find((r) => r.id === value);
          updated.rate = rt ? Number(rt.base_price) : 0;
          updated.room_id = null;
          updated.override = false;
        }

        return updated;
      })
    );
  };

  const toggleOverride = (uid, checked) => {
    setRoomRows((prev) =>
      prev.map((row) => (row.uid === uid ? { ...row, override: checked } : row))
    );
  };

  const updatePrice = (uid, value) => {
    setRoomRows((prev) =>
      prev.map((row) =>
        row.uid === uid ? { ...row, rate: Number(value) } : row
      )
    );
  };

  const addRoomRow = () => setRoomRows((prev) => [...prev, emptyRoomRow()]);
  const removeRoomRow = (uid) =>
    roomRows.length > 1 &&
    setRoomRows((prev) => prev.filter((r) => r.uid !== uid));

  // -------------------------
  // SUBMIT PAYLOAD
  // -------------------------

  const handleSubmit = async () => {
    if (!validateBooking()) return;
    const payload = {
      title: guestTitle,
      name: guestName,
      mobile_no: guestMobile,
      email: guestEmail,
      company_id: null,
      city_ledger: false,

      check_in: checkIn + "T14:00:00Z",
      check_out: checkOut + "T11:00:00Z",

      source_of_booking: "",
      arrival_from: "",
      booking_type: "",
      booking_reference_no: "",
      remarks,

      rooms: roomRows.map((r) => ({
        room_id: r.room_id,
        rate_type_id: r.rate_type_id,
        override_price: r.override ? r.rate : null,
        adults: r.adults,
        children: r.children,
      })),
    };

    try {
      const res = await api.post("/pms/reservations", payload);
      onAddReservation(res.data);
      onClose();
    } catch (err) {
      console.error("Save failed", err);
      alert("Failed to save reservation");
    }
  };

  if (!isOpen) return null;

  // -----------------------------------------------------------------------------
  // UI
  // -----------------------------------------------------------------------------

  return (
    <>
      <div className="right-sidebar-overlay open" onClick={onClose}></div>

      <div
        className="right-sidebar open bg-white shadow-lg"
        style={{
          width: "700px",
          right: 0,
          top: 0,
          bottom: 0,
          position: "fixed",
          zIndex: 2000,
          overflowY: "auto",
        }}
      >
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <h5 className="mb-0">Add New Booking</h5>
          <CloseButton onClick={onClose} />
        </div>

        <div className="p-3">
          {/* DATE ROW */}
          <Row className="g-2 mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Check-in</Form.Label>
                <Form.Control
                  type="date"
                  value={checkIn}
                  onChange={(e) => {
                    const v = e.target.value;
                    setCheckIn(v);

                    const minOut = format(
                      addDays(parseISO(v), 1),
                      "yyyy-MM-dd"
                    );

                    if (parseISO(checkOut) <= parseISO(v)) setCheckOut(minOut);
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Check-out</Form.Label>
                <Form.Control
                  type="date"
                  min={format(addDays(parseISO(checkIn), 1), "yyyy-MM-dd")}
                  value={checkOut}
                  onChange={(e) => setCheckOut(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>Nights</Form.Label>
                <Form.Control value={nights} readOnly />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>Rooms</Form.Label>
                <Form.Control value={roomRows.length} readOnly />
              </Form.Group>
            </Col>
          </Row>

          {/* ROOMS */}
          <div className="mb-2 d-flex justify-content-between">
            <h6 className="text-muted text-uppercase small">Rooms</h6>
            <Button size="sm" onClick={addRoomRow} variant="outline-primary">
              + Add Room
            </Button>
          </div>

          {roomRows.map((row) => (
            <div key={row.uid} className="border rounded p-2 mb-3 bg-light">
              <Row className="g-3 align-items-center">
                {/* ROOM TYPE */}
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="small text-muted fw-semibold">
                      Room Type
                    </Form.Label>
                    <Form.Select
                      value={row.room_type_id || ""}
                      onChange={(e) =>
                        updateRow(
                          row.uid,
                          "room_type_id",
                          Number(e.target.value)
                        )
                      }
                    >
                      <option value="">Select Type</option>
                      {roomTypes.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* RATE TYPE */}
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="small text-muted fw-semibold">
                      Rate Type
                    </Form.Label>
                    <Form.Select
                      value={row.rate_type_id || ""}
                      disabled={!row.room_type_id}
                      onChange={(e) =>
                        updateRow(
                          row.uid,
                          "rate_type_id",
                          Number(e.target.value)
                        )
                      }
                    >
                      <option value="">Select Rate</option>
                      {availableRateTypesForRoomType(row.room_type_id).map(
                        (rt) => (
                          <option key={rt.id} value={rt.id}>
                            {rt.name}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* ROOM */}
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="small text-muted fw-semibold">
                      Room
                    </Form.Label>
                    <Form.Select
                      value={row.room_id || ""}
                      disabled={!row.room_type_id}
                      onChange={(e) =>
                        updateRow(row.uid, "room_id", Number(e.target.value))
                      }
                    >
                      <option value="">Select Room</option>
                      {findRooms(row.room_type_id).map((room) => (
                        <option key={room.id} value={room.id}>
                          {room.room_number} — {room.status}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group>
                    <Form.Label className="small text-muted fw-semibold">
                      Adults
                    </Form.Label>
                    <Form.Select
                      value={row.adults}
                      disabled={!row.room_type_id}
                      onChange={(e) =>
                        updateRow(row.uid, "adults", Number(e.target.value))
                      }
                    >
                      {[1, 2, 3, 4].map((n) => (
                        <option key={n} value={n}>
                          {n}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label className="small text-muted fw-semibold">
                      Children
                    </Form.Label>
                    <Form.Select
                      value={row.children}
                      disabled={!row.room_type_id}
                      onChange={(e) =>
                        updateRow(row.uid, "children", Number(e.target.value))
                      }
                    >
                      {[0, 1, 2, 3].map((n) => (
                        <option key={n} value={n}>
                          {n}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="g-2 mt-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label className="small text-muted fw-semibold">
                      Rate
                    </Form.Label>

                    <InputGroup style={{ width: "160px" }}>
                      <InputGroup.Text>
                        <Form.Check
                          type="switch"
                          checked={row.override}
                          onChange={(e) =>
                            toggleOverride(row.uid, e.target.checked)
                          }
                        />
                      </InputGroup.Text>

                      <Form.Control
                        type="number"
                        value={row.rate}
                        disabled={!row.override}
                        onChange={(e) => updatePrice(row.uid, e.target.value)}
                        style={{
                          backgroundColor: row.override ? "white" : "#f1f3f4",
                          cursor: row.override ? "text" : "not-allowed",
                        }}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col md={2} className="text-end">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="mt-4"
                    onClick={() => removeRoomRow(row.uid)}
                  >
                    ✕
                  </Button>
                </Col>
              </Row>
            </div>
          ))}

          {/* GUEST INFO */}
          <h6 className="text-muted text-uppercase small mt-4">
            Guest Information
          </h6>

          <Row className="g-2 mb-3">
            <Col md={2}>
              <Form.Group>
                <Form.Label>Title</Form.Label>
                <Form.Select
                  value={guestTitle}
                  onChange={(e) => setGuestTitle(e.target.value)}
                >
                  <option>Mr</option>
                  <option>Ms</option>
                  <option>Mrs</option>
                  <option>Dr</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Full Name</Form.Label>

                <div style={{ position: "relative" }}>
                  <Form.Control
                    value={guestName}
                    onChange={(e) => {
                      setGuestName(e.target.value);
                      fetchGuestSuggestions(e.target.value);
                    }}
                  />

                  {showGuestDropdown && guestSuggestions.length > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "white",
                        border: "1px solid #ddd",
                        zIndex: 9999,
                        maxHeight: "200px",
                        overflowY: "auto",
                        borderRadius: "4px",
                      }}
                    >
                      {guestSuggestions.map((g) => (
                        <div
                          key={g.id}
                          onClick={() => handleSelectGuest(g)}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <strong>{g.name}</strong>
                          <div className="text-muted small">{g.mobile_no}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  value={guestMobile}
                  onChange={(e) => setGuestMobile(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2 mb-3">
            <Col md={8}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  value={guestEmail}
                  onChange={(e) => setGuestEmail(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* REMARKS */}
          <Form.Group className="mb-3">
            <Form.Label>Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </Form.Group>

          {/* TOTALS */}
          <Row className="mb-3">
            <Col md={6}>
              <div className="small text-muted">Subtotal</div>
              <div className="fw-bold">{subtotal.toLocaleString()}</div>
            </Col>
            <Col md={6} className="text-end">
              <div className="small text-muted">Total</div>
              <div className="fw-bold fs-4">{total.toLocaleString()}</div>
            </Col>
          </Row>

          <div className="d-grid gap-2">
            <Button onClick={handleSubmit} variant="primary">
              Save Booking
            </Button>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingSidebar;
